<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerNARKAs">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(nARKA)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { NARKAService } from "../../../services/NARKAService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "NARKAPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      nARKA: null,
      nARKAService: new NARKAService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerNARKAs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.nARKA) {
        return {
          title: this.nARKA.value,
          id: this.ids[0],
          status: this.getStatus(this.nARKA.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.nARKA) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.nARKA.code,
            },
          ],
          [
            {
              title: this.$t("nARKAValue"),
              text: this.nARKA.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.nARKA) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.nARKA.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.nARKA.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.nARKA.createdAt) +
                " " +
                getAMorPM(this.nARKA.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.nARKA.lastUpdated) +
                " " +
                getAMorPM(this.nARKA.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots ? this.filterAccessDots(options, this.nARKA) : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getNARKA();
      } catch (e) {
        this.hasError = true;
      }
    },
    getNARKA() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.nARKAService.get(this.ids[0]).then((res) => {
          this.nARKA = res.data;
          this.loading = false;
        });
      }
      this.nARKA = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.nARKA);
    },
    deletePanel() {
      this.$emit("delete", this.nARKA);
    },
    showHistoryPanel() {
      this.$emit("history", this.nARKA);
    },
  },
};
</script>

<style scoped></style>
